import { InputSwitch } from 'primereact/inputswitch';
import React, { useState, useRef, useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import Overlay from '../../Components/Overlay/Overlay';
import { getRoles } from '../../Services/RoleService';
import { createUser, getUserIdentity, getUserById, updateUser } from '../../Services/UserService';
import { def_picture } from '../../Images'
import { handlerFormError } from '../../Utils/Utils';
import { toastError } from '../../Components/Toasts/Toast';
import { useSelector } from 'react-redux';
import { updateImage } from "../../Stores/Action/AuthAction";
import { useDispatch } from 'react-redux';
import { Uploader } from 'rsuite';
import 'rsuite/dist/rsuite.min.css'

const { $ } = window;
let procesingId = -1;

const UserDetailScreen = () => {
  const dispatch = useDispatch();
  const { pageState, id } = useParams();
  const { userInfo } = useSelector(state => state.auth);
  const [isnotvalid, setIsNotValid] = useState(false);
  const [state, setState] = useState({
    user: {
      role: { _id : -1 }
    },
    roles: [],
    processing: false,
    email: '',
    emails: [],
    selectedEmail: null,
    isFocus: false,
    withPassword: true,
    file_icon: '',
  });

  const { register, handleSubmit, watch, control, setValue, formState: { errors }, reset } = useForm({ defaultValues: { role_id: '', is_active: true } });
  const password = useRef({});
  password.current = watch("password", "");

  const iconUpload = e => {
    if (e.length > 0) {
      if(e[0].blobFile.size >= 500000 ){ //size in Byte
          Swal.fire({
              icon: 'error',
              title: 'Save data failed!',
              text: 'Avatar file size exceed limit max 500Kb, [uploaded size is : '+ parseFloat(e[0].blobFile.size / 1000).toFixed(0) +'Kb] Pls remove manually'
          }).then(r => {
              setState({ ...state, file_icon: ''});
              setIsNotValid(true);
          })
      }else if (e[0].blobFile.type.toString() != 'image/png' && e[0].blobFile.type.toString() != 'image/gif'  && e[0].blobFile.type.toString() != 'image/jpg' && e[0].blobFile.type.toString() != 'image/jpeg'){
          Swal.fire({
              icon: 'error',
              title: 'Save data failed!',
              text: 'Avatar file type must png/gif/jpg/jpeg, Pls remove manually' 
          }).then(r => {
              setState({ ...state, file_icon: ''});
              setIsNotValid(true);
          })
      }else{
          setState({ ...state, file_icon: e[0].blobFile});
          setIsNotValid(false);
      }
    }
  }

  const iconRemove = e => {
      setState({ ...state, file_icon: '' });
      setIsNotValid(false);
  }

  useEffect(() => {
    const requests = [getRoles({ perpage: 100, filter: `is_active:true` }).then(res => res.data.data)];
    switch (pageState) {
      case 'add':
        Promise.all(requests).then(results => {
          const [_roles] = results;
          setState({ ...state, roles: _roles, user: {role: { _id : -1 }} });
        });
        break;
      case 'edit':
      case 'profile':
        requests.push(
          getUserById(id)
            .then(res => res.data)
            .catch(({ response: { data: { message } } }) => {
              Swal.fire({
                icon: 'error',
                title: 'Error when getting user',
                text: message
              }).then(() => { navigate(-1) });
            })
        );
        Promise.all(requests).then(results => {
          const [_roles, _user] = results;
          _user.image = _user.avatar;
          setState({ ...state, roles: _roles, user: _user, withPassword: false, email: _user.email });
          reset(_user);
        });
        break;
      default:
        break;
    }

  }, []);

  const navigate = useNavigate();

  const onBack = () => { navigate(-1); }

  const onSelectImage = () => {
    $('#user-image').click();
  }

  const onuserImageChange = e => {
    const [file] = e.target.files;
    if (file) {
      const _user = { ...user, image: URL.createObjectURL(file), file };
      setState({ ...state, user: _user });
    }
  }

  const startProcessing = () => {
    procesingId = setTimeout(() => {
      setState({ ...state, processing: true });
    }, 150);
  }

  const stopProcessing = () => {
    clearInterval(procesingId);
    setState({ ...state, processing: false });
  }

  const onChangeEmail = (e) => {
    const isMailModena = e.target.value.includes('@modena.com');
    if (isMailModena) {
      setState({ ...state, withPassword: false, email: e.target.value, isFocus: true });
    } else {
      setState({ ...state, withPassword: true, email: e.target.value, isFocus: true });
    }
  }

  const onChange = (event) => {
    var index = event.nativeEvent.target.selectedIndex;
    var keyValue = event.nativeEvent.target[index].value;
    var textValue = event.nativeEvent.target[index].text;
    const _user = { ...user, role: {_id: keyValue, role_name: textValue} };
    setState({ ...state, user: _user });
}

  const onSubmit = (data) => {

    if (isFocus) {
      toastError("You are inputed modena's email, please click email from list!");
      return;
    }

    data.avatar = user.file;
    const formData = new FormData();
    for (var key in data) {
      formData.append(key, data[key]);
    }

    if (withPassword) {
      formData.delete("retypePassword");
      if (pageState.toLowerCase() == 'edit') {
        formData.delete("password");
        formData.append('_method', 'put');
      }
    }

    if (pageState.toLowerCase() == 'edit') {
      formData.append('_method', 'put');
    }

    formData.append('avatar', file_icon);

    formData.append('role_name', user.role.role_name);

    startProcessing();
    const response = pageState.toLowerCase() == 'add' ? createUser(formData) : updateUser(id, formData);
    response.then(res => {
      if (res.status == 200 || res.status == 201) {
        Swal.fire({
          icon: 'success',
          title: 'Save data success',
          text: 'Data has been saved!'
        }).then(r => {
          onBack();

          if (user.image && userInfo.userid == id) dispatch(updateImage(user.image));
        })
      }
    }).catch(({ response: { data } }) => {
      handlerFormError(data);
    }).finally(_ => stopProcessing());
  }

  const { user, roles, processing, withPassword, email, emails, isFocus, selectedEmail, file_icon } = state;

  useEffect(() => {
    if (email != '') {
      const time = setTimeout(() => {
        getUserIdentity(email, ({ data }) => {
          if (data.total > 0) {
            setState({ ...state, emails: data.data });
          } else {
            setState({ ...state, isFocus: false });
          }
        });
      }, 150);

      return () => clearTimeout(time);
    } else {
      setState({ ...state, emails: [], isFocus: false });
    }

  }, [email]);

  const onSelectEmail = (item) => {
    setState({ ...state, selectedEmail: item, isFocus: false, withPassword: false });
    setValue('email', item.email);
    setValue('nik', item.emp_no);
    setValue('full_name', item.employe_name);
    setValue('phone', item.phone);
    setValue('employee_position', item.employee_position);
    setValue('organization_unit', item.organization_unit);
    setValue('job_title', item.job_title);
    setValue('job_status', item.job_status);
    setValue('work_location', item.work_location);
    setValue('cost_center', item.cost_center);
    setValue('username', item.email.replace('@modena.com', ''));
  };

  const onReset = () => {
    setState({ ...state, email: '', emails: [], selectedEmail: null, withPassword: true, isFocus: false, file_icon: '', user: {role: { _id : -1 }} })
    reset({
      email: '',
      nik: '',
      full_name: '',
      phone: ''
    });
  }

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">{pageState && pageState.charAt(0).toUpperCase() + pageState.slice(1)} User</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item"><NavLink to="/home">Home</NavLink></li>
                <li className="breadcrumb-item"><NavLink to="/user">User</NavLink></li>
                <li className="breadcrumb-item active">{pageState && pageState.charAt(0).toUpperCase() + pageState.slice(1)} User</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className='col-md-12'>
              <div className='card'>
                <Overlay display={processing} />
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className='card-header' style={{ height: 40}}>
                    <div className='card-title'><i className='fa fa-user-tag' /> {pageState && pageState.charAt(0).toUpperCase() + pageState.slice(1)} User </div>
                  </div>
                  <div className='card-body'>
                    <div className='row mt-3 mb-3'>
                      <div className='col-md-5 mx-auto'>
                        <div className='form-control'>
                          <div style={{ display: `inline-flex`} } >
                              {
                                  user.role._id != -1 && (
                                  <div className='form-control' style={{ marginRight: 10 }}>
                                      <img src= { process.env.REACT_APP_OBS_URL + user.avatar } style={{ height: 64, objectFit: 'cover' }} />
                                  </div> )
                              }
                              <div className='form-control' style={{ marginRight: 10 }}>
                                  <Uploader
                                      name="file_icon"
                                      multiple={false}
                                      autoUpload={false}
                                      listType="picture"
                                      value={file_icon}
                                      onChange={e => iconUpload(e)}
                                      disabled={file_icon == '' ? false : true}
                                      onRemove={e => iconRemove(e)}
                                      action=''>
                                  </Uploader>
                              </div>
                          </div>
                          <span style={{ display: 'flex', color: 'darkgrey', fontSize: 10 }}>Resolusi: 1280 x 70 (min width 640 pixel), Format: JPG/PNG/GIF, Max: 500Kb</span>
                        </div>
                      </div>
                    </div>
                    <div className='row mb-4'>
                      <div className='col-md-12'>
                        <div className="dropdown-divider" />
                      </div>
                    </div>
                    <div className='row'>
                      <label htmlFor="type_code">Fields with <span className='mandatory'></span> are required.</label>
                      <div className='col-md-6'>
                        <div className='form-group'>
                          <label htmlFor='email' className='mandatory'>Email</label>
                          <input id="email" {...register("email", {
                            onChange: onChangeEmail,
                            email: { value: true, message: 'Invalid email!' },
                            required: 'Email is required!',
                          })} className='form-control' type="email" readOnly={selectedEmail || pageState == 'profile'} />

                          {errors.email && <span className='text-danger'>{errors.email.message}</span>}

                          {emails.length > 0 && isFocus && !selectedEmail &&
                            <div className='mt-1 p-2' style={{ zIndex: 1, position: 'absolute', background: '#fff', border: '1px solid #ccc', borderRadius: 5, width: '31.2%' }}>
                              {
                                emails.map((item, i) =>
                                  <div onClick={() => onSelectEmail(item)} key={i} className='d-flex align-items-center w-100 p-1 mb-1' style={{ border: '1px solid #ccc', borderRadius: 5, cursor: 'pointer' }}>
                                    <span className='ml-2'>{item.email}</span>
                                  </div>
                                )
                              }
                            </div>
                          }
                        </div>

                        <div className='form-group'>
                          <label htmlFor='nik' className='mandatory'>NIK</label>
                          <input id="nik" {...register("nik", { required: 'NIK is required!' })} className='form-control' readOnly={selectedEmail || (user && email && email.includes('modena.com')) || pageState == 'profile'} />
                          {errors.nik && <span className='text-danger'>{errors.nik.message}</span>}
                        </div>
                        <div className='form-group'>
                          <label htmlFor='full_name' className='mandatory'>Full Name</label>
                          <input id="full_name" {...register("full_name", { required: 'Fullname is required!' })} className='form-control' readOnly={selectedEmail || (user && email && email.includes('modena.com')) || pageState == 'profile'} />
                          {errors.full_name && <span className='text-danger'>{errors.full_name.message}</span>}
                        </div>
                        <div className='form-group'>
                          <label htmlFor='phone' className='mandatory'>Phone</label>
                          <input id="phone" {...register("phone")} className='form-control' type="text" readOnly={selectedEmail || (user && email && email.includes('modena.com')) || pageState == 'profile'} />
                        </div>
                        <div className='form-group'>
                          <label htmlFor='role_id' className='mandatory'>Role</label>
                          <select id="role_id" className='form-control' {...register("role_id", { required: 'Role is required!' })} readOnly={pageState == 'profile'} onChange={(e) => onChange(e)}>
                            <option value="" >Select Role</option>
                            {roles.map((item, i) => <option key={`item-role-${i}`} value={item._id} selected={user.role._id == item._id ? true : false}>{item.role_name}</option>)}
                          </select>
                          {errors.role_id && <span className='text-danger'>{errors.role_id.message}</span>}
                        </div>
                      </div>

                      <div className='col-md-6'>
                        <div className='form-group'>
                          <label htmlFor='username' className='mandatory'>User Name</label>
                          <input id="username" {...register("username", { required: 'Username is required!' })} className='form-control' readOnly={pageState == 'profile'} />
                          {errors.username && <span className='text-danger'>{errors.username.message}</span>}
                        </div>

                        {withPassword && pageState.toLowerCase() != 'edit' && <> <div className='form-group'>
                          <label htmlFor='password'>Password</label>
                          <input id="password" {...register("password")} className='form-control' type="password" />
                          {errors.password && <span className='text-danger'>{errors.password.message}</span>}
                        </div>
                          <div className='form-group'>
                            <label htmlFor='retype-password'>Retype Password</label>
                            <input id="retype-password" {...register("retypePassword", { validate: val => password.current != '' && val == password.current || 'Password do not match' })} className='form-control' type="password" />
                            {errors.retypePassword && <span className='text-danger'>{errors.retypePassword.message}</span>}
                          </div></>}

                        <div className='form-group'>
                          <label htmlFor='active'>Active</label>
                          <div>
                            <Controller name="is_active" control={control} render={({ field }) => { return (<InputSwitch {...field} checked={field.value} disabled={pageState == 'profile'} />) }} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {
                    pageState != 'profile' &&
                    <div className='card-footer'>
                      <div className='row'>
                        <div className='col-md-12'>
                          <div className='d-flex' style={{ justifyContent: 'flex-end' }}>
                            <button type='button' className='btn btn-outline-dark mr-3' style={{ width: 100 }} onClick={onBack}><i className='fa fa-reply' /> Back</button>
                            {
                              !user && <button type='button' className='btn btn-danger mr-3' style={{ width: 100 }} onClick={onReset}><i className='fa fa-times' /> Clear</button>
                            }
                            <button type='submit' className='btn btn-dark' style={{ width: 100 }} disabled={isnotvalid}><i className='fa fa-save' /> Save</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </form>
              </div>
            </div>
          </div>
        </div >
      </section >
    </div >
  )
};

export default UserDetailScreen;
